import { render, staticRenderFns } from "./ManageTemplate.vue?vue&type=template&id=3aea80f2&"
import script from "./ManageTemplate.vue?vue&type=script&lang=ts&"
export * from "./ManageTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QSelect,QCard,QCardSection,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QSelect,QCard,QCardSection,QTable,QTd})
